import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'avs-confirmation-dialog',
  standalone: false,
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.css'
})
export class ConfirmationDialogComponent {

  public title: string = this.data.title;
  public message: string = this.data.message;
  public confirmButtonText: string = this.data.button_1;
  public cancelButtonText: string = this.data.button_2;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>) { }

  public onCloseModalClicked(): void {
    this.dialogRef.close();
  }

  public onConfirmButtonClicked(): void {
    this.dialogRef.close(true);
  }

  public onCancelButtonClicked(): void {
    this.dialogRef.close(false);
  }

}